// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ordered-list__item--lower-latin[data-v-f5c2247e]{list-style-type:lower-latin}.ordered-list__item[data-v-f5c2247e]::marker{background:#6d6d78;background:var(--c-color-03,#6d6d78)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
